import React, { useMemo } from 'react';

import PortShareImg from '@publicImages/svg/port-share.svg?static';

import Image from '@/components/Image';
import UIResource from '@/components/UIResource';
import { checkForValueType } from '@/helpers/util';

import './ItineraryList.scss';

const DisplayItineraryList = ({ arrivalTime, departureTime }) => {
  let id;
  const values = { arrivalTime, departureTime };
  if (arrivalTime && departureTime) {
    id = 'ItineraryDetail.sameDay';
  } else if (arrivalTime && !departureTime) {
    id = 'ItineraryDetail.arrivesAt';
  } else if (departureTime && !arrivalTime) {
    id = 'ItineraryDetail.departsAt';
  } else {
    return null;
  }
  return <UIResource id={id} values={values} />;
};

const Item = ({ component: Component = 'li', index, itinerary = {}, onClick }) => {
  const {
    arrivalPortMessage,
    arrivalTime,
    countryName,
    departureTime,
    imageIcon,
    itineraryDay,
    languageISOCode = 'en',
    portGuideURL,
    portName,
    seaDay,
  } = itinerary;

  const portNameCountry = useMemo(() => {
    const portNameElement = <span lang={languageISOCode}>{portName}</span>;

    if (!checkForValueType(countryName)) {
      return portNameElement;
    }

    return (
      <>
        {portNameElement},&nbsp;{countryName}
        {checkForValueType(portGuideURL) && (
          <span className="Icon portShareIcon">
            <PortShareImg />
          </span>
        )}
      </>
    );
  }, [languageISOCode, portName, countryName, portGuideURL]);

  const onItineraryClick = () => onClick?.(itinerary);

  return (
    <Component className="ItineraryListNew__item">
      <div className="ItineraryListNew__daySection">{itineraryDay}</div>
      <div className="ItineraryListNew__portsSection">
        <div className="ItineraryListNew__icon">
          <Image alt="ItineraryListIcon-img" aria-hidden className="ItineraryListNew__imageIcon" src={imageIcon.src} />
        </div>
        <div className="ItineraryListNew__body">
          <div className="ItineraryListNew__itemParagraph">
            {portGuideURL ? (
              <a
                className="ItineraryListNew__location"
                href={portGuideURL}
                onClick={onItineraryClick}
                rel="noopener noreferrer"
                target="_blank"
              >
                {portNameCountry}
              </a>
            ) : (
              <span className="ItineraryListNew__location">{portNameCountry}</span>
            )}
            {!seaDay && (
              <div className="ItineraryListNew__description">
                <DisplayItineraryList arrivalTime={arrivalTime} departureTime={departureTime} />
              </div>
            )}
            {index === 0 && (
              <div className="ItineraryListNew__allAboardSection">
                <UIResource id="ItineraryDetail.allaboard.text"></UIResource>
              </div>
            )}
            {arrivalPortMessage && <p className="ItineraryListNew__arrivalPortMessage">{arrivalPortMessage}</p>}
          </div>
        </div>
      </div>
    </Component>
  );
};

export default Item;
